module.exports = __webpack_public_path__ + "static/img/14areaB_7.27a6d16.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/14areaB_7.png
// module id = 1130
// module chunks = 1